import { useState } from 'react';
import { Link } from 'react-router-dom';
import HeroImage from '@/assets/images/services/about.jpeg';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

interface CTASectionProps {
  serviceType?: 'drafting' | 'takeoff';
}

export default function CTASection({ serviceType }: CTASectionProps) {
  const isTakeoff = serviceType === 'takeoff';
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-gradient-to-br from-[#e18033] to-[#c97029] rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-10 lg:p-16 flex flex-col justify-center">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                {isTakeoff 
                  ? "Ready to Scale Your Bidding Capacity?" 
                  : "Ready to Start Your Project?"}
              </h2>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                {isTakeoff 
                  ? "Stop losing bids due to estimating bottlenecks. Send us your blueprints today for a rapid, fixed-fee quote, and let our technicians handle the measurements so you can focus on winning the job." 
                  : "Get a free consultation and quote for your drafting or takeoff needs. Our team is ready to help bring your project to life."}
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm text-white/80">Call Us</div>
                    <div className="text-lg font-semibold text-white">+1.303.873.1100</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm text-white/80">Email Us</div>
                    <div className="text-lg font-semibold text-white">info@digitalmediainnovations.com</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <button 
                  onClick={() => setIsQuoteOpen(true)}
                  className="bg-white text-[#e18033] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Request Quote
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
                <Link 
                  to="/portfolio"
                  className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap flex items-center justify-center"
                >
                  View Portfolio
                </Link>
              </div>
            </div>

            <div className="relative h-96 lg:h-auto w-full">
              <img
                src={HeroImage}
                alt="Professional Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <RequestQuotePopup 
        isOpen={isQuoteOpen} 
        onClose={() => setIsQuoteOpen(false)} 
        serviceName={isTakeoff ? "Takeoff Services" : "Drafting Services"}
      />
    </section>
  );
}
